import { toast } from "react-toastify";
import { _single, _Sprint } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Section } from "../Section/Section";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../theme/Component/Modal";
import { InputDate } from "../../../../theme/Input/InputDate";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { SprintActivities } from "./SprintActivities/SprintActivities";
import { useSprintBoardContext } from "../../../ActivityTaskContext/SprintBoardProvider";
import { useState } from "react";
import { SelectProject } from "../../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { WorkActivityRelationGroup } from "../../../WorkActivity/WorkActivityRelationGroup/WorkActivityGroupRelation";


type SprintBean = {
    IDSprint: number;
    [key: string]: any;
};

type Sprint = {
    DataBeanProperties: SprintBean;
    DataBeanName: string;
};

interface PropsSprintSection {
    sprint: Sprint;
    expanded: boolean;
    onToggle: () => void;
}

export function SprintSection({ sprint, expanded, onToggle }: PropsSprintSection) {

    const { loadSprints } = useSprintBoardContext();
    const { instance, bean, setBean, isMissing, isRequired, validateForm, addRequiredFields } = useDataBean(_Sprint);
    const sprintData = sprint.DataBeanProperties;

    const [modalText, setModalText] = useState<string>("");
    const [targetState, setTargetState] = useState<number | null>(null);

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Periodo de Trabajo", MODAL_SM);
    const modalUpdateState = useModal("", MODAL_md);
    const modalTeams = useModal("Grupos de Trabajo Involucrados", MODAL_LG);

    function formatDateTime(value?: string, notTime?: boolean) {
        if (!value) return "—";

        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return value;

        const options: Intl.DateTimeFormatOptions = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            ...(!notTime && {
                hour: "2-digit",
                minute: "2-digit",
            }),
        };

        return new Intl.DateTimeFormat("es-CO", options).format(d);
    }

    function SprintDates({ stateName, from, to, project }: { stateName: string, from?: string; to?: string, project: string }) {
        return (
            <div className="d-flex m-2 align-items-center gap-3 text-muted small">
                <span style={{
                    flex: "0 1 420px",
                    maxWidth: "300px",
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }} className="">
                    <strong>Proyecto: </strong>{project ?? "N/P"}
                </span>
                <span className="text-nowrap">
                    <strong>{formatDateTime(stateName ?? "N/A")}</strong>
                </span>
                <span className="text-nowrap">
                    <strong>Inicio:</strong> {formatDateTime(from, true)}
                </span>
                <span className="text-nowrap">
                    <strong>Fin:</strong> {formatDateTime(to, true)}
                </span>
            </div>
        );
    }

    const metaLeft = <SprintDates project={sprint.DataBeanProperties.ProjectName} stateName={sprint.DataBeanProperties.StateName} from={sprint.DataBeanProperties.FromDate} to={sprint.DataBeanProperties.UptoDate} />;

    const actions = (
        <div className="d-flex gap-2">
            {sprint.DataBeanProperties.State != 2 &&
                <button
                    title="Empezar a Supervisar"
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        setBean(sprint.DataBeanProperties)
                        setTargetState(2)
                        setModalText(`Al iniciar la supervisión del periodo, será capaz de visualizar la información en los tableros`)
                        modalUpdateState.open(`Iniciar Supervisión del Periodo ${sprint.DataBeanProperties.SprintName}`)
                    }}
                    className="btn btn-icon cursor btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none">
                    <i className="ri-share-box-line fs-22"></i>
                </button>
            }
            {sprint.DataBeanProperties.State == 2 &&
                <button
                    title="Detener Supervisión"
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        setBean(sprint.DataBeanProperties)
                        setTargetState(3)
                        setModalText(`Al detener la supervisión del periodo, ya no será capaz de visualizar la información en los tableros`)
                        modalUpdateState.open(`Detener Supervisión del Periodo ${sprint.DataBeanProperties.SprintName}`)
                    }}
                    className="btn btn-icon cursor btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none">
                    <i className="ri-login-box-line fs-22"></i>
                </button>
            }
            {expanded &&
                <>
                    <button
                        title="Editar"
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            setBean(sprint.DataBeanProperties)
                            modalTeams.open();
                        }}
                        className="btn btn-icon cursor btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none">
                        <i className="ri-team-fill fs-22"></i>
                    </button>
                    <button
                        title="Editar"
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            setBean(sprint.DataBeanProperties)
                            modal.open(`Editar ${sprint.DataBeanProperties.SprintName}`)
                        }}
                        className="btn btn-icon cursor btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none">
                        <i className="ri-edit-2-line fs-22"></i>
                    </button>
                    <button
                        title="Eliminar"
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            setBean(sprint.DataBeanProperties)
                            modalC.open()
                        }}
                        className="btn btn-icon cursor btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none">
                        <i className="ri-delete-bin-line fs-22"></i>
                    </button>
                </>
            }
        </div>
    );

    const changeState = (newState: number) => {
        const x = { ...bean, State: newState };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan campos Obligatorios por dilienciar")
            return;
        }

        const x = { ...obj, IDAccount: _single.getAccountID() }

        instance.updateSprint(x).then(
            () => {
                loadSprints();
                modal.close();
            }
        ).catch((err) => toast.error(err));
    };

    return (
        <>
            <Section title={sprintData.SprintName} expanded={expanded} onToggle={onToggle} metaLeft={metaLeft} headerRight={actions} >
                {expanded && (
                    <SprintActivities sprintId={sprintData.IDSprint} />
                )}
            </Section>

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => editaItem(bean)}>
                <div className="row">
                    <div className="col-md-12">
                        <label className={`${isMissing('SprintName') ? 'has-error' : ''}`}>Declaracion de importación {isRequired('SprintName') ? <span className="text-danger">*</span> : ''}</label>
                        <input
                            className="form-control"
                            value={bean.SprintName}
                            onChange={(e) =>
                                setBean({ ...bean, SprintName: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-md-12">
                        <label className={`${isMissing('IDProject') ? 'has-error' : ''}`}>Proyecto Asociado {isRequired('IDProject') ? <span className="text-danger">*</span> : ''}</label>
                        <SelectProject idSelector={bean.IDProject} onChange={(e) => { setBean({ ...bean, IDProject: e }) }} label=" " />
                    </div>

                    <div className="col-md-12">
                        <label className={`${isMissing('FromDate') ? 'has-error' : ''}`}>Fecha de Inicio {isRequired('FromDate') ? <span className="text-danger">*</span> : ''}</label>

                        <InputDate
                            name="FromDate"
                            label=" "
                            value={bean.FromDate}
                            setDate={(e) =>
                                setBean({ ...bean, FromDate: e })
                            }
                        />
                    </div>

                    <div className="col-md-12">
                        <label className={`${isMissing('UptoDate') ? 'has-error' : ''}`}>Fecha de Finalización {isRequired('UptoDate') ? <span className="text-danger">*</span> : ''}</label>

                        <InputDate
                            name="UptoDate"
                            label=" "
                            value={bean.UptoDate}
                            setDate={(e) =>
                                setBean({ ...bean, UptoDate: e })
                            }
                        />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalTeams.modal} updateModal={modalTeams.setModal}>
                <WorkActivityRelationGroup Sprint={bean} />
            </Modal>

            <Modal
                modal={modalUpdateState.modal}
                updateModal={modalUpdateState.setModal}
                eventModal={() => {
                    if (targetState !== null) {
                        changeState(targetState)
                        modalUpdateState.close()
                    }
                }}
            >
                <div className="row">
                    <div className="col">
                        <p>{modalText}</p>
                    </div>
                </div>
            </Modal>

            <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={() => { changeState(4) }}>
                <strong>Eliminar item {bean.SprintName}</strong>
            </ModalConfirm>
        </>
    );
}